module.exports = __webpack_public_path__ + "static/media/PC_Data_e_Wokshop_BIG_DATA_E_DATA_MINING.b91c10e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/bigData_Mining/PC_Data_e_Wokshop_BIG_DATA_E_DATA_MINING.png
// module id = 93
// module chunks = 0